<template>
  <div class="isTxt" v-if="isTxt">
    {{ innerValue || '-' }}
  </div>
  <RxkSelect
    v-else
    :list="list"
    allow-create
    filterable
    default-first-option
    :reserve-keyword="false"
    v-model="innerValue"
    clearable
  />
</template>
<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkSelect } from '@/components/common/RxkSelect'
import { isNullOrUndefOrEmpty } from '@/utils/is'
import { getDetaultValue } from '@/apis/objectManage'
import type { List } from '@/types/common'
import {
  getPageComponentDataDisplayAcquire,
  getPageComponentDataEchoAcquire
} from '@/apis/customerManage'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'refreshDataList'])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})
const list = ref<List[]>([])

onMounted(() => {
  if (isNullOrUndefOrEmpty(innerValue.value)) {
    console.log('会执行吗2321', props.data, innerValue)
    // 关联已有数据，要去调接口查出list
    const defaultValueConfigInfo = props.data.defaultValueConfigInfo
    if (defaultValueConfigInfo) {
      const postData = {
        connectColumnSerial: defaultValueConfigInfo.connectColumnSerial,
        connectTableCode: defaultValueConfigInfo.connectTableCode,
        connectType: defaultValueConfigInfo.connectType,
        conditionInfo: defaultValueConfigInfo.conditionInfo,
        sourceTableCode: defaultValueConfigInfo.sourceTableCode,
        sourceTableAlias: defaultValueConfigInfo.sourceTableAlias,
        sourceColumnSerial: defaultValueConfigInfo.sourceColumnSerial,
        sourceTableField: defaultValueConfigInfo.sourceTableField,
        sourceFieldCode: defaultValueConfigInfo.sourceFieldCode,
        sourceFieldType: defaultValueConfigInfo.sourceFieldType,
        sourceDataMark: defaultValueConfigInfo.sourceDataMark
      }
      getDetaultValue(postData).then(res => {
        let listArr: Recordable[] = []
        if (res.dataList && res.dataList.length) {
          listArr = res.dataList.map((item: Recordable) => {
            return {
              label: item[defaultValueConfigInfo.connectColumnSerial],
              value: item[defaultValueConfigInfo.connectColumnSerial]
            }
          })
          listArr = listArr.filter(item => item.value)
          Promise.all(
            listArr.map(item => {
              return (async () => {
                // 要处理dataMark
                if (defaultValueConfigInfo.sourceDataMark === 2) {
                  const postData = {
                    columnSerial: defaultValueConfigInfo.sourceColumnSerial,
                    echoData: item.value,
                    tableCode: defaultValueConfigInfo.sourceTableCode
                  }
                  const res1 = await getPageComponentDataDisplayAcquire({
                    ...postData
                  })
                  item.label = res1.map((item: Recordable) => item.label).join(',')
                } else if (defaultValueConfigInfo.sourceDataMark === 1) {
                  if (res.valueLabelList && res.valueLabelList.length) {
                    const tempArrValue: any[] = String(item.value).split(',')
                    let resultArr: Recordable[] = []
                    resultArr = res.valueLabelList.filter((item: Recordable) => {
                      if (tempArrValue?.includes(String(item.value))) {
                        return item
                      }
                    })
                    item.label = resultArr.map((item: Recordable) => item.label).join(',')
                  }
                } else {
                  item.label = item.value
                }
                return { ...item }
              })()
            })
          ).then(res => {
            innerValue.value = res[0]?.value || ''
            list.value = res
            console.log(innerValue.value)
            console.log(list, 'lkkkk')
          })
        }
      })
    }
  }
})
</script>
